<template>
    <div class="wrapper-form-add-button box has-background-white">
        <a tabindex="-1" class="is-add-button has-text-dark p-0" @click="emitCampo">
            <span class="icon is-size-4">
                <i class="mdi mdi-plus-circle-outline"></i>
            </span>
          </a>
    </div>
  </template>
  <script>
  export default {
    name: 'TrfAddButton',
    emits: ['insert:campo'],
    methods: {
      emitCampo(event) {
        event.preventDefault();
        event.stopPropagation();
        this.$emit('insert:campo')
      }
    }
  };
  </script>
  <style lang="scss" scoped>
    .is-add-button {
      width:1.5rem;
      height:1.5rem;
    }
  </style>